import TinyStore from 'lib/tinyStore';
import { UniprofileFormData } from 'types/provider';
import { initApplicationFormData } from 'store/ChannelApplicationProvider';
import { INewUniprofileResume } from 'types/newUniprofile';

type DataModal = {
    loading?: boolean,
    data?: UniprofileFormData | INewUniprofileResume,
};

const Store = TinyStore.createStore<DataModal>({
    nameSpace: 'klarity',
    key: 'uniprofileResume',
    crossBundle: false,
    runTime: true,
    initValue: { data: { ...initApplicationFormData }, loading: false },
});
export default Store;
